export default function IconSplit(props) {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <path d="M12 2v10M8 18l4 4 4-4M4 12h4M16 12h4"/>
    </svg>
  )
}
